import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__bool } from '../../_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__paste_with_mask extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__PASTE_WITH_MASK;

  /*
   *
   */

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE,
      field_role: '1️⃣ Image Source',

      data__is_required: false,
    },
  )
  image_source!: FIELD__image_asset;

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: '2️⃣ Image Target', data__is_required: false },
  )
  image_target!: FIELD__image_asset;

  //
  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.MASK },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: '🔳 Image Mask', ui__has_component: false },
  )
  image_mask!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input({
    value: 0,
    value_range: new DTO__number_range(0, 32),
    values_allowed: new DTO__number_range(0, 32),
    //
    slider_step: 1,
  })
  mask_blur!: FIELD_PRIMITIVE__int;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: true })
  invert_mask!: FIELD_PRIMITIVE__bool;

  /*
   *
   */
  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out__image!: FIELD__image_asset;

  constructor() {
    super(ENUM__invocation_type.IMAGE__PASTE_WITH_MASK);
  }

  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance): boolean {
    let has_effect_source = this.image_source.find_source(graph).has_effect_on_generation_runtime(graph);
    let has_effect_target = this.image_target.find_source(graph).has_effect_on_generation_runtime(graph);
    let has_effect_mask = this.image_mask.find_source(graph).has_effect_on_generation_runtime(graph);

    if (!has_effect_source && !has_effect_target) return false;
    if (!has_effect_mask) return false;

    let out = super.has_effect_on_generation_runtime(graph);

    return out;
  }
}
